/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// Libraries
import React from 'react';
import {
    object, shape, string, array,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
// UI Components
import ProductsViewed from '../ProductsViewed/ProductsViewed';
import ProductImageUIMobileBlock from './Partials/ProductImageUIMobileBlock';
import ProductPlaImageUIMobile  from './Partials/ProductPlaImageUIMobile';
import ProductPlantsImageUIMobile from '../../GraphqlPlantsProductPageBuilder/Partials/ProductPlantsImageUIMobile';

const styles = (theme) => ({
    container: {
        display: 'flex',
        margin: '2px 0 5px 0',
    },
    img: {
        flexBasis: '50%',
    },
    retail: {
        color: theme.palette.error?.main,
        marginRight: '5px',
        textDecoration: 'line-through',
    },
    sale: {
        color: theme.palette.primaryButton,
        fontWeight: 'bold',
    },
    plaSlide: {
        alignSelf: 'center',
        width: '100%',
        height: 'auto',
        scrollSnapAlign: 'start',
        flexShrink: 0,
        scrollBehavior: 'smooth',
    },
    plaSummaryContainer: {
        padding: '10px 10px 0',
        flexBasis: '50%',
        fontSize: '18px',
    },
    plaProdName: {
        margin: '0 0 10px',
        fontSize: '21px',
        fontWeight: '400',
    },
    plaDelivery: {
        color: theme.palette.colorPrimary,
        padding: '10px 0',
    },
    root: {
        position: 'relative',
        marginBottom: '5px',
        overflow: 'hidden',
    },
    sliderContainer: {
        display: 'flex',
        overflowX: 'auto',
        width: '100%',
        scrollSnapType: 'x mandatory',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '& .slick-dots': {
            // bottom: 15,
            '& button': {
                '&:before': {
                    fontSize: 20,
                },
            },
        },
    },
    plantsSliderContainer: {
        width: '100%',
        scrollSnapType: 'x mandatory',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '& .slick-dots': {
            // bottom: 15,
            '& button': {
                '&:before': {
                    fontSize: 20,
                },
            },
        },
    },
    slide: {
        marginRight: '20px',
        alignSelf: 'center',
        width: '100%',
        height: 'auto',
        scrollSnapAlign: 'start',
        flexShrink: 0,
        scrollBehavior: 'smooth',
    },
    productNameContainer: {
        justifyContent: 'space-around',
        alignItems: 'center',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '50px',
        color: 'white',
        fontWeight: '700',
        background: 'rgba(0,0,0,.5)',
        '& > $productName': {
            marginTop: '12px',
        },
        '& > div + div$productName': {
            marginTop: '0',
        },
    },
    productName: {
        fontSize: '24px',
        fontWeight: 600,
        padding: '15px',
        paddingBottom: 0,
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '20px',
            paddingRight: '20px',
        },
    },
    sliderDotsContainer: {
        display: 'flex',
        margin: '6px 0',
        justifyContent: 'center',
    },
    dotsActive: {
        marginRight: '10px',
        width: '10px',
        height: '10px',
        background: '#fff',
        borderRadius: '100%',
    },
    dotsInactive: {
        marginRight: '10px',
        width: '10px',
        height: '10px',
        background: 'rgba(255, 255, 255, .5)',
        borderRadius: '100%',
    },
    productNameforNormal: {
        textAlign: 'center',
        padding: '8px 0',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    productImageSliderContainer: {
        justifyContent: 'space-around',
        alignItems: 'center',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '30px',
        color: 'white',
        fontWeight: '700',
        background: theme.palette.common?.black || '#000',
        opacity: '0.5',
    },
    imageContainer: {
        position: 'relative',
    },
    snipe: {
        position: 'absolute',
        top: '0px',
        width: '100%',
        pointerEvents: 'none',
    },
    plantsSlide: {
        minHeight: 330,
    },
    plantsImageContainer: {
        position: 'relative',
    },
    satisfactionImage: {
        position: 'absolute',
        bottom: '25px',
        right: '15px',
        zIndex: '1',
        width: '84px',
        height: 'auto',
    },
});

const ProductImageUIMobile = ({
    classes,
    product = {},
    content,
    selectedSku = {},
    presentation_family,
    productNameDisplay,
    history,
    productName: itemName,
    brand,
}) => {
    if (!product) {
        return null;
    }
    if (!selectedSku) {
        return null;
    }
    const productName = itemName || product.name;
    const additionalImages = product.image?.additionalImages;
    const snipeImagePath = product.image?.snipeImagePath;
    const snipe = product.image?.snipe;
    const deliveryMessage = product.availability.deliveryMessage;
    const productSkus = product.productSkus;
    const partNumber = product?.partNumber;
    // Convert the image name to lowerCase for particular product
    const getProductUrl = history?.location?.pathname?.includes('treasured-memories-174292');
    const name = getProductUrl ? selectedSku?.image?.name?.toLowerCase() : selectedSku?.image?.name;
    const path = selectedSku.image?.path;
    // Checking functionality for test case
    const search = history?.entries?.[0]?.search?.includes('adtype=pla');
    const productsViewed = content?.entries?.[0]?.products_viewed_section;
    if (brand.code === 'PLA') {
        return (
            <ProductPlantsImageUIMobile
                classes={classes}
                productName={productName}
                name={name}
                path={path}
                snipe={snipe}
                snipeImagePath={snipeImagePath}
                additionalImages={additionalImages}
                presentation_family={presentation_family}
                productNameDisplay={productNameDisplay}
                brand={brand}
                partNumber={partNumber}
            />
        );
    }
    if ((typeof window !== 'undefined' && window?.location?.href.includes('adtype=pla'))  || search) {
        return (
            <>
                {presentation_family !== 'food'
            && <ProductsViewed productsViewedData={productsViewed} />}
                <ProductPlaImageUIMobile
                    classes={classes}
                    name={name}
                    path={path}
                    additionalImages={additionalImages}
                    productName={productName}
                    deliveryMessage={deliveryMessage}
                    productSkus={productSkus}
                />
            </>
        );
    }
    return (
        <>
            {presentation_family !== 'food'
                && <ProductsViewed productsViewedData={productsViewed} />}

            <ProductImageUIMobileBlock
                classes={classes}
                productName={productName}
                name={name}
                path={path}
                snipe={snipe}
                snipeImagePath={snipeImagePath}
                additionalImages={additionalImages}
                presentation_family={presentation_family}
                productNameDisplay={productNameDisplay}
                brand={brand}
            />
        </>
    );
};

ProductImageUIMobile.propTypes = {
    classes: object.isRequired,
    product: shape({
        name: string.isRequired,
        image: shape({
            additionalImages: array.isRequired,
            snipeImagePath: string.isRequired,
            snipe: string.isRequired,
        }).isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
        }).isRequired,
    }).isRequired,
    content: object.isRequired,
    selectedSku: shape({
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }),
    }).isRequired,
    presentation_family: string.isRequired,
    productNameDisplay: string.isRequired,
    history: object.isRequired,
    productName: string.isRequired,
    brand: object,
};

ProductImageUIMobile.defaultProps = {
    brand: {},
};

export default withRouter(connect(null)(withStyles(styles)(ProductImageUIMobile)));
